import { baseApi } from "../baseApi";

export const DashboardApi = baseApi.injectEndpoints({
   endpoints: (builder) => ({
        postDashboardChart: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/frappe.desk.query_report.run`,
                method: 'POST',
                body: customerData,
            })
        }),
        postDashboardChartTwo: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/frappe.desk.doctype.dashboard_chart.dashboard_chart.get`,
                method: 'POST',
                body: customerData,
            })
        }),
        postDashboardChartThree: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/erpnext.stock.dashboard_chart_source.warehouse_wise_stock_value.warehouse_wise_stock_value.get`,
                method: 'POST',
                body: customerData,
            })
        }),
        postDashboardCount: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/frappe.desk.doctype.number_card.number_card.get_result`,
                method: 'POST',
                body: customerData,
            })
        }),
        postDashboardCounttwo: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/frappe.desk.reportview.get_count`,
                method: 'POST',
                body: customerData,
            })
        }),
        postDashboardCountthree: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/frappe.desk.query_report.run`,
                method: 'POST',
                body: customerData,
            })
        }),
        postSaveFilter: builder.mutation({
            query: (input) => ({
                url: `/api/method/frappe.desk.form.save.savedocs`,
                method: 'POST',
                body: input,
            })
        }),
        postDashboardPercentageCount: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/frappe.desk.doctype.number_card.number_card.get_percentage_difference`,
                method: 'POST',
                body: customerData,
            })
        }),
    })
});

export const { usePostSaveFilterMutation,usePostDashboardChartThreeMutation,usePostDashboardChartMutation,usePostDashboardCountMutation,usePostDashboardPercentageCountMutation,usePostDashboardChartTwoMutation,usePostDashboardCounttwoMutation, usePostDashboardCountthreeMutation } = DashboardApi;
